import type { IoTDataPoint, StationTelemetryOverlayEntry } from '@/features/realtime/types/realtime.types';

/** Resolve socket overlay for a station (`id` and/or `code:${sensorId}`). */
export function pickTelemetryOverlay(
  station: IoTDataPoint,
  telemetry: Record<string, StationTelemetryOverlayEntry>,
): StationTelemetryOverlayEntry | undefined {
  const byId = telemetry[station.id];
  const codeKey = station.sensorId?.trim() ? `code:${station.sensorId.trim()}` : '';
  const byCode = codeKey ? telemetry[codeKey] : undefined;
  if (byId && byCode) {
    return byId.lastUpdated >= byCode.lastUpdated ? byId : byCode;
  }
  return byId ?? byCode;
}
